import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const ExportFileSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0001 12.586C12.5524 12.586 13.0001 13.0337 13.0001 13.586V18.171L14.1206 17.0505C14.5113 16.6597 15.1448 16.6597 15.5355 17.0505C15.9263
      17.4412 15.9263 18.0748 15.5355 18.4655L12.0001 22L8.46471 18.4655C8.07391 18.0748 8.07387 17.4412 8.46462 17.0505C8.85534 16.6597 9.48882 16.6597
      9.87954 17.0505L11.0001 18.171V13.586C11.0001 13.0337 11.4478 12.586 12.0001 12.586Z"
      fill="currentColor"
    />
    <path
      d="M12.0067 2C13.7237 2.00008 15.3808 2.63111 16.6629 3.77312C17.9451 4.91512 18.7628 6.48846 18.9607 8.194C20.205 8.53332 21.2905 9.2991 22.0274
      10.3575C22.7643 11.416 23.1059 12.6997 22.9923 13.9844C22.8788 15.2691 22.3174 16.473 21.4063 17.3858C20.7617 18.0316 19.971 18.5026 19.1087
      18.7639C18.5312 18.9389 18.0077 18.458 18.0077 17.8545C18.0077 17.3435 18.3925 16.9251 18.8639 16.7279C19.0172 16.6638 19.1661 16.5886 19.3093
      16.503C19.7083 16.2644 20.0557 15.9487 20.3313 15.5744C20.6069 15.2001 20.8052 14.7746 20.9146 14.3228C21.024 13.8711 21.0423 13.402 20.9684
      12.9431C20.8946 12.4841 20.7301 12.0445 20.4844 11.6498C20.2388 11.2552 19.9171 10.9134 19.5379 10.6445C19.1588 10.3755 18.7299 10.1848 18.2762
      10.0834C17.8226 9.98203 17.3533 9.97203 16.8957 10.054C17.0523 9.32489 17.0439 8.56997 16.8709 7.84455C16.698 7.11913 16.365 6.44158 15.8963
      5.86153C15.4276 5.28147 14.8351 4.81361 14.1622 4.49219C13.4893 4.17078 12.753 4.00397 12.0072 4.00397C11.2615 4.00397 10.5252 4.17078 9.85226
      4.49219C9.17933 4.81361 8.58682 5.28147 8.11813 5.86153C7.64944 6.44158 7.31644 7.11913 7.14351 7.84455C6.97059 8.56997 6.96212 9.32489 7.11873
      10.054C6.20639 9.88267 5.26335 10.0808 4.49707 10.6048C3.7308 11.1287 3.20406 11.9357 3.03273 12.848C2.8614 13.7603 3.05952 14.7034 3.58349 15.4697C4.10747
      16.2359 5.09439 16.7927 6.00673 16.964C7.12079 17.1732 7.00671 19 6.00673 18.978C5.00675 18.956 3.51914 18.2989 2.60786 17.3862C1.69659 16.4735 1.13506 15.2696
      1.0214 13.9848C0.907751 12.7001 1.24921 11.4163 1.9861 10.3578C2.72299 9.29926 3.80844 8.53339 5.05273 8.194C5.25044 6.48838 6.06814 4.91491 7.35031
      3.77287C8.63248 2.63082 10.2897 1.99986 12.0067 2Z"
      fill="currentColor"
    />
  </svg>
);

const ExportFile = (props: IIconProps) => <Icon component={ExportFileSvg} {...props} />;

export default ExportFile;
